module.exports = __webpack_public_path__ + "static/media/outline-icons.cd6c777f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styling/theme/assets/fonts/outline-icons.woff2
// module id = ./src/styling/theme/assets/fonts/outline-icons.woff2
// module chunks = 0